import {
  Condition,
  Condition as ModelCondition,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import {
  ConditionType,
  ConditionTypeDetailsProps,
} from "../../return-flow/condition";

export type SentFromEmailState = Omit<Condition.SentFromEmail, "type">;

export const SENT_FROM_EMAIL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<SentFromEmailState>>,
): ConditionType<SentFromEmailState, Condition.SentFromEmail> => ({
  name: "Email sent from",
  description() {
    return "The email address of the sender of the email";
  },
  Details(props: ConditionTypeDetailsProps<SentFromEmailState>) {
    return React.createElement(Details, props);
  },
  empty: { emails: [], matchMode: "INCLUDES" },
  fromModel(model) {
    return { emails: model.emails, matchMode: model.matchMode };
  },
  toModel(state) {
    return {
      type: ModelCondition.SENT_FROM_EMAIL,
      emails: state.emails,
      matchMode: state.matchMode,
    };
  },
  valid(state) {
    return !!state.emails.length;
  },
});
